// extracted by mini-css-extract-plugin
module.exports = {"container":"_3a2b3a","top":"_578832","avatar":"_0d76c0","text":"_cdc3c3","more":"_42aea4","name":"_1d607a","rate":"_fc4e2a","description":"_825161"};